import React from "react";
import {
  Box,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
  Typography,
} from "@mui/material";

export const PDP_WHATSAPP_LABEL_PRESETS = [
  { value: "combine-frete", label: "Combine o frete com o consultor" },
  { value: "compre-whatsapp", label: "Compre pelo WhatsApp" },
  { value: "fale-consultor", label: "Fale com o consultor" },
  { value: "custom", label: "Texto personalizado" },
];

export function emptyPdpWhatsappFrete() {
  return {
    format: "pdp_whatsapp_frete.v1",
    enabled: true,
    labelKey: "combine-frete",
    customLabel: "",
    benefitsGridEnabled: true,
  };
}

export function sanitizePdpWhatsappFrete(src) {
  const v = src && typeof src === "object" ? src : {};
  const labelKeyRaw = String(v.labelKey || v.label_key || "combine-frete").trim();
  const presets = new Set(PDP_WHATSAPP_LABEL_PRESETS.map((p) => p.value));
  const labelKey = presets.has(labelKeyRaw) ? labelKeyRaw : "custom";
  const customLabel = String(v.customLabel || v.custom_label || "").trim();
  return {
    format: "pdp_whatsapp_frete.v1",
    enabled: !(v.enabled === false || v.enabled === 0 || v.enabled === "0"),
    labelKey: labelKey === "custom" && !customLabel ? "combine-frete" : labelKey,
    customLabel: labelKey === "custom" ? customLabel : "",
    benefitsGridEnabled: !(
      v.benefitsGridEnabled === false ||
      v.benefits_grid_enabled === false ||
      v.benefitsGridEnabled === 0 ||
      v.benefits_grid_enabled === 0
    ),
  };
}

/** Editor do conteúdo PDP — Botão WhatsApp / frete (padrões da loja). */
export default function PdpWhatsappFreteEditor({ value, onChange }) {
  const data = sanitizePdpWhatsappFrete(value);

  const patch = (partial) => onChange(sanitizePdpWhatsappFrete({ ...data, ...partial }));

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Página do produto — padrões da loja
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Usados quando o produto não define configuração própria. Se o produto tiver
        valor explícito, ele prevalece.
      </Typography>

      <FormControlLabel
        control={
          <Switch
            checked={!!data.enabled}
            onChange={(e) => patch({ enabled: e.target.checked })}
          />
        }
        label="Exibir botão WhatsApp na página do produto"
        sx={{ display: "block", mb: 1 }}
      />

      <FormControl fullWidth size="small" sx={{ mb: 2, maxWidth: 420 }} disabled={!data.enabled}>
        <InputLabel>Texto do botão WhatsApp</InputLabel>
        <Select
          label="Texto do botão WhatsApp"
          value={data.labelKey}
          onChange={(e) => patch({ labelKey: e.target.value })}
        >
          {PDP_WHATSAPP_LABEL_PRESETS.map((p) => (
            <MenuItem key={p.value} value={p.value}>
              {p.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {data.labelKey === "custom" && data.enabled ? (
        <TextField
          fullWidth
          size="small"
          sx={{ mb: 2, maxWidth: 420 }}
          label="Texto personalizado do botão"
          value={data.customLabel}
          onChange={(e) => patch({ customLabel: e.target.value })}
          placeholder="Ex.: Combine a entrega pelo WhatsApp"
        />
      ) : null}

      <FormControlLabel
        control={
          <Switch
            checked={!!data.benefitsGridEnabled}
            onChange={(e) => patch({ benefitsGridEnabled: e.target.checked })}
          />
        }
        label="Exibir blocos Retire na Concessionária e Aplicação"
        sx={{ display: "block" }}
      />
    </Box>
  );
}
